export const CREATE_VENDOR_START = "CREATE_VENDOR_START";
export const CREATE_VENDOR_SUCCESS = "CREATE_VENDOR_SUCCESS";
export const CREATE_VENDOR_FAIL = "CREATE_VENDOR_FAIL";

export const GET_VENDOR_DATA_TABLE_START = "GET_VENDOR_DATA_TABLE_START";
export const GET_VENDOR_DATA_TABLE_SUCCESS = "GET_VENDOR_DATA_TABLE_SUCCESS";
export const GET_VENDOR_DATA_TABLE_FAIL = "GET_VENDOR_DATA_TABLE_FAIL";

export const SET_VENDOR_PAGE_SIZE = "SET_VENDOR_PAGE_SIZE";

export const SET_VENDOR_SEARCH_INPUT = "SET_VENDOR_SEARCH_INPUT";

export const SET_VENDOR_CURRENT_PAGE = "SET_VENDOR_CURRENT_PAGE";

export const SET_VENDOR_DETAILS = "SET_VENDOR_DETAILS";
export const SET_VENDOR_DATE = "SET_VENDOR_DATE";

export const GET_CITY_START = "GET_CITY_START";
export const GET_CITY_SUCCESS = "GET_CITY_SUCCESS";
